export default __webpack_public_path__ + "static/media/Finance_Blue.c194ddf4.svg";